import React, { Component } from 'react';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { withCookies } from 'react-cookie';

import TabPanelBankBalance from './TabPanelBankBalance';
import { isAuthenticated } from '../../actions/authentication';
import { RenewToken } from '../../utils/token';
import styles from '../../styles/bankBalance.module.css';
import { ChatContext } from '@/ChatProvider';

class BankBalance extends Component {
    
    constructor(props) {
        super(props)
        this.state = { authenticated: false }
    }

    componentDidMount() {
        this.handleTitle();
        this.handleToken();
    }

    async handleToken() {
        await RenewToken(this.props);

        isAuthenticated().then((result) => {
            this.setState({ authenticated: result });
            this.context.setIsAuthenticated(result);
        });
    }

    handleTitle() {
        this.props.onLoadTitle(i18next.t('menu:bankBalance'));
    }

    render() {
        return (
            this.state.authenticated && <div className={styles.rootBankBalance}>
                <TabPanelBankBalance />
            </div>
        );
    }
}

BankBalance.contextType = ChatContext;
export default withNamespaces(['menu'], { wait: true })(withCookies(BankBalance));